"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_number_format_1 = __importDefault(require("react-number-format"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ product, cartItemIndex, }) {
    var _a;
    const { images, name, price, amount } = product;
    const imgUrl = ((_a = images[0]) === null || _a === void 0 ? void 0 : _a.img_url) || '';
    const minusDisabled = amount <= 1;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(CartProductBarDiv, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                    position: 'relative',
                    width: '48px',
                    height: '48px',
                    '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '4px' }),
                    '> .inner_item': {
                        width: '100%',
                        height: '100%',
                        borderRadius: '4px',
                        objectFit: 'cover',
                    },
                } }, { children: imgUrl ? ((0, jsx_runtime_1.jsx)("img", { className: "inner_item", src: (0, functions_1.getCdnUrl)(imgUrl) })) : ((0, jsx_runtime_1.jsx)("div", { className: "inner_item surface-table-row" })) })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, direction: "column", justifyContent: "space-around", height: "100%", p: "0 10px" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text_overflow cart_product_name " }, { children: name })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "cart_product_price" }, { children: (0, string_utils_1.money)(price) }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "amount_div" }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ disabled: minusDisabled, onClick: () => dispatch((0, roomViewStore_1.decreaseCartItemAmount)(cartItemIndex)) }, { children: (0, jsx_runtime_1.jsx)(svgs_1.MinusIconSvg, { css: { path: { strokeOpacity: minusDisabled ? 0.1 : 1 } } }) })), (0, jsx_runtime_1.jsx)(react_number_format_1.default, { allowNegative: false, isAllowed: ({ value }) => Number(value) <= 9999, decimalScale: 0, value: amount, onValueChange: e => {
                            const inputNum = Number(e.value);
                            if (inputNum)
                                dispatch((0, roomViewStore_1.setCartItemAmount)({ cartItemIndex, inputNum }));
                        }, onBlur: (e) => {
                            const inputNum = Number(e.target.value.replace(/\D/g, ''));
                            if (inputNum <= 0)
                                dispatch((0, roomViewStore_1.setCartItemAmount)({ cartItemIndex, inputNum: 1 }));
                        }, suffix: t('개') }), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => dispatch((0, roomViewStore_1.increaseCartItemAmount)(cartItemIndex)) }, { children: (0, jsx_runtime_1.jsx)(svgs_1.PlusIconSvg, {}) }))] })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: {
                    position: 'absolute',
                    top: '-8px',
                    right: '-8px',
                }, onClick: () => dispatch((0, roomViewStore_1.deleteFromCart)(cartItemIndex)) }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: { width: '16px', height: '16px' } }) }))] }));
}
exports.default = default_1;
const CartProductBarDiv = styled_1.default.div `
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: 48px auto 120px;
  height: 64px;
  padding: 8px 10px;
  border-radius: 4px;
  background-color: #f8f8f8;
  .cart_product_name {
    /* .text_overflow in base_react.html */
    -webkit-line-clamp: 1;
    line-height: 16px;
    font-size: 14px;
    font-weight: 600;
  }
  .cart_product_price {
    line-height: 19px;
    font-size: 16px;
  }
  .amount_div {
    display: grid;
    grid-template-columns: 24px auto 24px;
    height: 40px;
    border: 0.5px solid black;
    border-radius: 100px;
    padding: 6px 8px;
    background-color: white;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    .MuiIconButton-root {
      padding: 0;
      margin: -6px;
    }
    input {
      width: 100%;
      border: 0;
      border-radius: 2px;
      background-color: #f8f8f8;
      text-align: center;
      font-size: 14px;
      :focus {
        outline: none;
        border: 0.5px solid black !important;
        background-color: white;
      }
    }
  }
  @media (max-width: 370px) {
    grid-template-columns: 48px auto 100px;
  }
`;
